export const GET_DASHBOARD_STATS = 'GET_DASHBOARD_STATS';
export const GET_DASHBOARD_STATS_SUCCESS = 'GET_DASHBOARD_STATS_SUCCESS';
export const GET_DASHBOARD_STATS_FAILED = 'GET_DASHBOARD_STATS_FAILED';